<template>
    <div class="help">
        <div v-if="params.t_id" class="page page-series-title">
            <div v-if="dataBase.length" class="second-title-list">
                <div v-for="(heading,index) in dataBase"
                     @click="jumpNextPage(3,heading.id)"
                     :key="'a'+index" class="second-title">
                    {{(index+1)+'.'+heading.title}}
                </div>
            </div>
        </div>
        <div v-else-if="params.d_id" class="page page-details">
            <div ref="content" class="content" @click="judgeClick" v-html="aimHeading.details"></div>
            <div v-show="aimHeading.id" ref="help" :class="['is-help-wrapper',helpClass]">
                <div @click="clickHelp(0)"
                     :class="['help-button','help-yes',{'help-active':helpActive===0}]">役に立った
                </div>
                <div @click="clickHelp(1)"
                     :class="['help-button', 'help-no',{'help-active':helpActive===1}]">役に立たなかった
                </div>
            </div>
        </div>
        <div v-else @click="showSearch=false" class="page page-main-and-search">
            <template v-if="dataBase.firstLevelHeading">
                <div class="search-part">
                    <div @click.stop="focus()" class="search-wrapper">
                        <input @input="changeList()"
                               v-model="input"
                               ref="input"
                               type="text" :placeholder="'例：'+randomFonts[randomIndex]">
                        <button v-if="input.length===0" @click="changeList(1)">搜索</button>
                        <div  v-else class="reset" @click="changeList(2)"></div>
                    </div>
                </div>
                <div class="list list-main">
                    <div class="title">カテゴリーから探す</div>
                    <div class="all-questions">
                        <div v-for="(title1,index) in dataBase.firstLevelHeading"
                             :key="'1'+index"
                             @click="jumpNextPage(2,index+1)"
                             class="question">
                            {{title1}}
                        </div>
                    </div>
                    <div class="title title-2">よくあるご質問</div>
                    <div class="second-title-list">
                        <div v-for="(heading,index) in dataBase.hot"
                             @click="jumpNextPage(3,heading.id)||tracker.track('click_hotsearch_'+heading.id)"
                             :key="'a'+index" class="second-title">
                            {{(index+1)+'.'+heading.title}}
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="showSearch" @click.prevent class="search-result">
                <div class="second-title-list">
                    <transition-group
                            :css="false"
                            @before-enter="beforeEnter"
                            @enter="enter"
                            @leave="leave">
                        <div v-for="(heading,index) in dataBase.searchResult"
                             @click="jumpNextPage(3,heading.id)"
                             :key="index+' '+heading.id" class="second-title">
                            {{heading.title}}
                        </div>
                    </transition-group>
                </div>
            </div>
        </div>
        <div id="loading" v-show="isLoading"></div>
    </div>
</template>
<script type="es6">
const { request } = require('../../../common/module/request');
const { Tracker } = require('../../../common/module/Tracker');
const { bridge } = require('../../../common/module/bridge');
const { util: { openUrl, getUrlStrs, getEnv } } = require('../../../common/module/util');

export default {
    name: 'App',
    data: () => {
        return {
            params: getUrlStrs(),
            dataBase: {
                searchResult: []
            },
            input: '',
            isLoading: false,
            aimHeading: {},
            helpClass: 'relative',
            helpActive: -1,
            randomFonts:['アカウント','イベント','ゴールド','未成年','連携'],
            randomIndex:0,
            randomInterval:{},
            tracker:{},
            showSearch: true //0、mainPage 1、搜索结果 2、某个一级标题下的全部二级标题 3、详情页
        };
    },
    methods: {
        jumpNextPage: function(pageIndex, params) {
            this.tracker.track('click_tag_'+params);
            let prefix = getEnv() === 'cdn' ? 'https://www.doki.live/static/doki/online' : 'http://test.doki.live/static/doki/dev';
            let content = prefix + '/cli/help/dist/index_pc.html?';
            if (pageIndex === 2) content += 't_id=' + params;
            if (pageIndex === 3) content += 'd_id=' + params;
            location.href=content;
        },
        getConstants: function() {
            this.isLoading = true;
            let name = 'help';
            request({
                method: 'GET',
                hybrid: false,
                baseUrl: "https://jp.api.dokidokilive.com",
                url: '/api/events_v2/admin/events_resource/',
                data: {
                    event_name: name
                },
                callback: function(d) {
                    this.isLoading = false;
                    this.tracker = new Tracker('Doki_FAQ', 'enter_H5');
                    if (d.err_code === 0) {
                        this.dataBase = d.data[name];
                        let title = document.getElementsByTagName('title')[0];
                        if (this.params.t_id) {
                            let headingIndex = this.params.t_id;
                            title.innerHTML=this.dataBase.firstLevelHeading[headingIndex-1];
                            this.dataBase = this.dataBase.secondLevel.filter(item => {
                                return String(item.id).startsWith(headingIndex + '');
                            });
                        } else if (this.params.d_id) {
                            this.aimHeading = this.dataBase.secondLevel.filter(item => {
                                return item.id === +this.params.d_id;
                            })[0];
                            title.innerHTML=this.aimHeading.title;
                            this.$nextTick(() => {
                                let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                                let contentHeight = this.$refs.content.offsetHeight;
                                if (contentHeight < windowHeight * .8) {
                                    this.$refs.help.style.position = 'fixed';
                                    this.$refs.help.style.bottom = '18%';
                                } else {
                                    this.$refs.help.style.padding = '100px 0 240px';
                                }
                            });
                        }
                    } else {
                        alert(d.err_msg);
                    }
                }.bind(this)
            });
        },
        changeList: function(need) {
            if (need===1){
                this.tracker.track('click_search_example');
                this.input=this.randomFonts[this.randomIndex];
            }
            if (need===2) this.input='';
            if (this.randomInterval) {
                clearInterval(this.randomInterval);
                this.randomInterval=null;
            }
            if(this.dataBase.searchResult) this.dataBase.searchResult.length=0;
            if (this.input.length===0) {
                this.dataBase.searchResult.length=0;
            }else{
                this.dataBase.searchResult = this.dataBase.secondLevel.filter(item => {
                    return item.title.toLowerCase().indexOf(this.input.toLowerCase()) >= 0;
                });
            }
        },
        clickHelp: function(type) {
            if (this.helpActive !== -1) return;
            this.helpActive = type;
            this.tracker.track((!type?'click_usefull_': 'click_useless_')+this.aimHeading.id);
        },
        beforeEnter: function(el) {
            el.style.opacity = 0;
            el.style.height = 0;
        },
        enter: function(el, done) {
            var delay = el.dataset.index * 150;
            setTimeout(function() {
                Velocity(
                    el,
                    { opacity: 1, height: '30px' },
                    { complete: done }
                );
            }, delay);
        },
        leave: function(el, done) {
            var delay = el.dataset.index * 150;
            setTimeout(function() {
                Velocity(
                    el,
                    { opacity: 0, height: 0 },
                    { complete: done }
                );
            }, delay);
        },
        judgeClick: function(event) {
            let targetDom = event.target;
            if (targetDom.getAttribute('data-type') === 'jump') {
                let aimUrl = targetDom.getAttribute('data-url');
                if (aimUrl.startsWith('details')) this.jumpNextPage(3, aimUrl.split('-')[1]);
                if (aimUrl.startsWith('entry')) location.href = "http://www.maetimes.jp/about?type=consult";
                // if (aimUrl.startsWith('about')) location.href="https://www.doki.live/static/doki/dest/about_us.html";
            }
        },
        focus:function() {
            this.showSearch=true;
            this.$refs.input.focus();
        }
    },
    mounted: function() {
        this.getConstants();
        if (!(this.params.t_id||this.params.d_id)) {
            this.randomInterval= setInterval(()=>{
                this.randomIndex=Math.floor(Math.random()*this.randomFonts.length);
            },3000);
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss">
    @import "../../../common/sass/basic/_common";
    @import "../../../common/sass/basic/_mixin";

    $breakpoints: (
            'sm': 'only screen and ( max-width: 767px)',
            'lg': 'only screen and ( min-width: 768px)',
            'slg': 'only screen and ( min-width: 960px)',
    ) !default;

    @mixin respond-to($breakpoint) {
        $query: map-get($breakpoints, $breakpoint);
        @if not $query {
            @error 'No value found for `#{$breakpoint}`. Please make sure it is
                defined in `$breakpoints` map.';
        }
        @media #{if(type-of($query) == 'string', unquote($query), inspect($query))}
        {
            @content;
        }
    }

    @keyframes rotate {
        0%{
            transform: rotate(0);
        }
        100%{
            transform: rotate(360deg);
        }
    }

    #loading {
        position: fixed;
        background-image: url("https://rescdn.dokidokilive.com/fex/doki/static/loading.png");
        @include respond-to(sm){
            @include img_size(23px, 23px);
        }
        @include respond-to(lg){
            @include img_size(30px, 30px);
        }
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        @include animation(rotate 1.0s infinite linear);
        z-index: 1000;
    }

    .hoverCursor{
        &:hover{
            cursor: pointer;
        }
    }
    html{
        font-size: 16px;
    }
    body{
        @include respond-to(slg){
           background-color: #efefef;
        }
    }

    .help{
        @include respond-to(sm){
            width: 100vw;
            padding: 0 15px;
            box-sizing: border-box;
        }
        @include respond-to(lg){
            width: 768px;
        }
        @include respond-to(slg){
            width: 960px;
            padding-left: 96px;
            padding-right: 96px;
            box-sizing: border-box;
            min-height: 100vh;
            background-color: white;
        }
        margin: 0 auto;

        //公共部分
        .second-title-list {
            padding-bottom: 26px;

            .second-title {
                max-width: 80%;
                height: 30px;
                color: #292929;
                line-height: 30px;
                position: relative;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 20px;
                background-color: white;
                transition: color .1s;
                overflow-y: hidden;

                &::-webkit-scrollbar{
                    height: 0;
                }

                &:hover{
                    color: #64c1ee;
                }
                @extend .hoverCursor;
            }
        }

        .page-main-and-search {
            min-height: 100vh;
            position: relative;

            .search-part {
                padding-top: 34px;
                padding-bottom: 68px;
                background-color: white;

                .search-wrapper {
                    @include respond-to(sm){
                        width: 90vw;
                    }
                    @include respond-to(lg){
                        width: 545px;
                    }
                    height: 44px;
                    margin: 0 auto;
                    background-color: white;
                    border-radius: 11px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    position: relative;
                    border: 1px solid #999999;

                    input {
                        margin-left: 20px;
                        width: 400px;
                        display: inline-block;
                        outline: none;
                        font-size: 16px;
                        border: none;
                        flex-shrink: 1;

                        &::-webkit-input-placeholder {
                            color: #dbdbdb;
                        }
                    }

                    button {
                        width: 80px;
                        height: 30px;
                        flex-shrink: 1;
                        border-radius: 8px;
                        background-color: #4cb7eb;
                        outline: none;
                        border: none;
                        font-size: 14px;
                        color: white;
                        margin-right: 8px;

                        &:active{
                            background-color: darken(#4cb7eb,10%);
                        }
                        @extend .hoverCursor;
                    }

                    .reset{
                        $size:16px;
                        background-image: url("../../assets/X.png");
                        background-size: $size $size;
                        height: $size;
                        width: $size;
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                }
            }

            .list {
                background-color: white;
                position: relative;

                &.list-main {

                    .title {
                        font-size: 20px;
                        font-weight: bolder;
                        height: 30px;
                        line-height: 30px;

                        &.title-2 {
                            margin-top: 50px;
                            margin-bottom: 33px;
                        }
                    }

                    .all-questions {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        margin-top: 23px;

                        @include respond-to(sm){
                            align-content: space-around;
                            .question{
                                margin-top: 10px;
                            }
                        }

                        @include respond-to(lg){
                            align-content: space-between;
                            .question{
                                &:nth-of-type(n+6) {
                                    margin-top: 20px;
                                }
                            }
                        }

                        .question {
                            height: 50px;
                            width: 130px;
                            box-sizing: border-box;
                            border: 1px solid #4d4d4d;
                            color: #4d4d4d;
                            font-size: 16px;
                            text-align: center;
                            line-height: 50px;
                            border-radius: 10px;
                            transition: color .1s;
                            margin-right: 22px;

                            &:hover{
                                color: #64c1ee;
                                border-color: #64c1ee;
                            }

                            @extend .hoverCursor;


                        }
                    }

                    @include respond-to(sm){
                        padding-left: 20px;
                    }
                }

            }

            .search-result{
                position: absolute;
                background-color: white;
                @include respond-to(lg){
                    width: 545px;
                }
                @include respond-to(sm){
                    width: 90vw;
                }

                top: 79px;
                left: 50%;
                transform: translateX(-50%);
                .second-title{
                    width: 100%;
                    margin-top: 0;
                    text-indent: 19px;
                    &:hover{
                        background-color: #efefef;
                        color: #000;
                    }
                    @extend .hoverCursor;
                }
            }
        }

        .page-series-title {
            padding-top: 44px;
        }

        .page-details {

            .content {
                padding-top: 44px;
                word-break: break-all;
                line-height: 36px;
                color: #282828;

                a{
                    color: #4cb7eb;
                }

                a:active{
                    color: darken(#4cb7eb,10%);
                }


                .point-black {
                    padding-left: 30px;
                    position: relative;

                    &:after {
                        content: "";
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        background-color: black;
                        position: absolute;
                        top: 18px;
                        left: 10px;
                        transform: translateY(-50%);
                    }
                }

                .point-empty {
                    padding-left: 30px;
                    position: relative;

                    &:after {
                        content: "";
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        border: 1px solid black;
                        box-sizing: border-box;
                        position: absolute;
                        top: 18px;
                        left: 10px;
                        transform: translateY(-50%);
                    }
                }

                img {
                    display: inline-block;
                    margin-top: 10px;

                    &.image3-1-2, &.image3-1-1, &.image7-3-1, &.image-9 {
                        @include respond-to(lg){
                            height: 350px;
                            width: 690px;
                        }
                        @include respond-to(sm){
                            width: 90vw;
                            height: calc(90vw * 35 / 69);
                        }
                    }
                }

                .jump {
                    text-decoration: underline;
                    color: #4cb7eb;
                    font-weight: normal;
                    @extend .hoverCursor;

                    &.jump-no{
                        &:hover{
                            cursor: default;
                        }
                    }

                }
                .span2 {
                    background-size: 20px 20px;
                    width: 20px;
                    height: 20px;
                    display: inline-block;
                    vertical-align: middle;
                }

                .pic_1 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABmCAMAAAAOARRQAAAAkFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD9/f0uLi4AAAC4uLh4eHj7+/vY2NikpKRAQEAgICAAAAAAAADy8vKtra2bm5tWVlb09PTQ0NC9vb1ISEgWFhYAAAD5+fn39/fr6+uMjIzn5+fj4+PExMSzs7Nvb29lZWXd3d3Jycnu7u7////3q3pmAAAAL3RSTlNmAFFfBDYkEloaC0j8cj20jvnQp3huQjLsrKGB8Mi4e2ws9vPkmeDbvbGKhtXB6KTgiSMAAAMdSURBVGje1ZrZetowEEb/SLJkjA0O2Oxb2BIgqd//7dq0Accqy4xsXHpufHk+LR6NRoMnKkb3W03hSwlIKUTP00Y9USFpVMMTEmcQLR1UpFG6KXEF0TflNY2exE2EVmU0SgvQkF7A1eQSHwxagZMml5BHpNgaI8DH10xNX8KJZsDQBAKuyAZZ05AogadoGg/lEAFBo3ooi29uapQAAfYCgWNx94Bk4WN5wLbwx2NrmqgOGVzSeKgSX53XaFRL86zGSFSMZ2m4y8/fbuAvDH95co3BPWhZGiVwF0xR84L7IAoaJcEiGrV3mwgEdK7hrn8yzT4J3yLKLsg1gQSDwzL7YjCnDgfswSSr7MQgJQ4H7JXpZN+YEYcDbjBLsu88L3ALcdQIMBhlBWLavwNuAGgXNSNaBAV3N/M1/h+NDwbzNWPS8lkDb842y6JluaCdO2CFs1lm0SYGNjDyjOjVtqwXoBD80kgQiSd/WRKAFj9hQGQYHn/J7kf4+/uWkpMCaJCITjHmxxhIN91uvGCcOvBu7eD9eAEcBkfLNAUb+YSrOyBtDz5np7M7TljYhQsKApc52Is+OMAJA4mLjJeWpRPBDY0rWL9JuIMr10JAXLRMYjjTx2U+ipoE7niUOSuvaeEy26JmDHd6t3KLnPROmi4n5rtPWvRc9LxHd9kCGGZFJvsqN3TO1PKEQ+ffU14dz1e4WZ3CTeoYbMSNG8b0vbMbp4XTho9Bk3t2jsBHwQON/eR0sC3ms/VqtW1HjGNNg0j0fjp1wmNSQD+kDT+vzSHuPI+TQAHxyvbsqQkUq+yUbC3NKzkdfAGHN8szpya3BmU8G8rS5BcP12ydstmMwzVqyB6N73IpjNlr47lccVFIEbe0OeNf2DFi3gmFW/kBU97BrbnFlHyzMWKar5iloZzxxyAM17MEBDSj0OWOrxhlO3d0PUXImkqq9RSIayp311O8r+cpop6HlZqeiep59KrnCe+fP0hW+Lz6EI/FFT19P8xDfgVtCY/VZFGqZeQRG2Ac23ketzmJ22r18I1j1Da4/6ip73uLohC+hEuL4k8Bh5A+sDoP3wAAAABJRU5ErkJggg==');
                }

                .pic_2 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABmCAMAAAAOARRQAAAAXVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAABAQEAAAAAAAAAAAADExMT4+Pjx8fGxsbH09PS2trb9/f36+vrd3d3T09NpaWlcXFz8/Py9vb2mpqaRkZEbGxuFhYXt7e3///82J/4vAAAAHnRSTlNmADkbWg1HeC1gT7317K7vsvz41cqIg/u4qJttleemolNvAAACxUlEQVRo3tXa65KjIBAF4DM0IF6SjLlMbru+/2NuasyENYo2KKx7/pky9ZWEaAuND24UGaELmedALmWhhSHF/jJ4hNESA5HaqKUYEpYYogTNZ5Q1xiQ1iyENZjQFM1TAIwUFMUrDM1r5MwIBEZ4MSQRFkg8jEBzBZlSBGSkUj6Ecs5IThzGYHTPNCCwQ4WSsEsNBT4niII4CCDdjsGCMiyEsGhpmVL4sk6tBRmLhyCFGYPGIPkOIEOoxEhEi3xmBKBFdRiFSVIfRiBRtGfbvf900r2yu3FlgmQKcfDadfIKTwjLEVUIcejGaqQQ5+odRTCXQUU9G8JRQRzwZiaGUVdPPJsN3sk3TT1ViKLJlaFhpXIrbaS6uSQDXmLmvZex6XKMG15g5lAnHNWpwzbNhZcpxzTW46owJxToMxjwYPcZswcx2jNEPRo4xmAjvfPkBhfgMFMjra9n2sDvvfx+2mRdDMB5MdqybnxwzD8ZA8Jlf++av7G98RkCzmWvzliub0Si4zK3p5cZlCkgmk+37zD5jMhI5kzm2H9Tl6X4/lfVzHjCZnMtk7fHuqz382rXHGZfBNGNvJueH8nTO9mY0zYDLHL4Py/fH3oHJcAetHaQTXjm1g7jwb9OOUe+EmsvIQObuw0gUKQatgE4xBTREigktYFL8PQ0oxc2GoFLcOhU+ZPwHgeQUUO7HGruAYpSDVTn1kC6rqXKQVdxebMnRDJQc5XRxyyrVq24BVde7TgFVTTGS9+JhmbAzBe816jLOXKbOJMZLoZ0Cbmf8TGlfcWNG2Bf2mFF2+SFidGcxJVqIvTQUHrs0FPlyKM2yXaJFyDRLqmkWiBMtd6dZvE+zFZFoYyXNNlGaTa80W3j/fkNyMUesY7N4ma3v9Wzkz29LWFeTxayWkTU2wAS286y3Ocm31Wr9jWPMNrj/qalvoEUx921R/ANQ4Y8VBIAL6wAAAABJRU5ErkJggg==');
                }

                .pic_4 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,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');
                }

                .pic_5 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAQlBMVEUAAAA9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgI9GgJV9g3CAAAAFXRSTlMA7xtzL772ejzQog1uWciQmYfoUbFT/8snAAABbElEQVRYw+1VSZLDIAwcgc1i8B79/6tTFbmixBgCOswhk75F4I660fLzxT9DN2qtx078vRsACTA4UQI9PqNvT8XiGbaRYcAUg5yBOSQqTD+vc2/atXRIAB3uv4MFJFR7erzFpB4R5Y93qa2HgyE8xcJEQdfiJaiXoIIWR+myPkU1ETeYacIpHEy9oSMZlzF5rKGgjJckvpC++rpak/iaqy55FnIvGso7eZGWEodL0bahLpQvVKdXNW4CFnoEIb5NgUxLOpUYagztNiRk5gUpLDLw1WRqMXRJxSMHjwk4uhcoPO+MywlOu2UuNwcnqs1Z0z28W1eSYThP4TZb6G4U7lSeSrfzZrevm13FmH3Unf7wTQE7g2hcTkfNhKZH85nDib0sgFLNHG6kQ0zBhx9P4XzSdK6NQhlMYFQTRcQLxD+gkApJAXO9nVms9QWeA9RSWDEF4yYWwrBbxs7GNqgdOXI4QAQn/pzH7xefj18le0ys4YtU8gAAAABJRU5ErkJggg==');
                }

                .pic_6 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAAS1BMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMwrhPl3AAAAGHRSTlMA8XiIOxBQcGhEIszgtqYsG13n05LbNb5HE4OFAAABoklEQVRYw+2WW3KDMAxFkZ+8IZAS7X+lHSIaJ8hgK/3qNOcPzXBshLim+PDPsFWpVFnZt+/3DW40/i2LAnwClFgwzLijqWWGCpABRmJYACPAkG8YJ9z46q+6b3GjzW9qh0S30LW5IdFnNwKJMpQ8Ernt2NZ0z7XLtq88Q4139Gv1StUxb6ZwZdrPKtDDCZqp92UtaGgbGsebPGcp8I6NtwgECla2AoVwF/JeSN8IH4xeMhf2F3Pho9OpMVtR3xCj38hGlwwvB/jgEsplqILLeoh9XlCHg5rDFwuppXX/hYGUwzzujGfnw7UcGWyLhC8MRAwLvW82YDxVpjWo6yZ6jmxqOE8rGKKnmafqAHfd+Saq8zPVAe0zCq3ap0720Zf2aKhYvorRkpS3zhyeHpcsg5kQ5/EgaYYsA4Su8W7abAO2idRNG7ARKnyv7asBjUzRrRuvXwyuECkqRHIwQ0LBYq91ZTAIFTX+wAxcoRh+HSHFDDHwCDDBwQxpRRgAxQwSBVAEMQNjPt1FcDjBPzP7cVaHhhBHOoYfwypXPRQfPvwlvgHMPVSiXfAfwAAAAABJRU5ErkJggg==');
                }

                .pic_7 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAABmCAMAAADhw39uAAAAh1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARERH5+fkAAAD9/f1QUFAtLS1hYWEAAAC4uLjs7Ozc3NzJyclBQUFra2vi4uLY2Nj7+/vy8vKhoaGKioo4ODgAAADu7u7T09PNzc3ExMS0tLSlpaV1dXX29vatra2UlJTo6Oi/v7////+TkHi1AAAALHRSTlNmAAhfFjVTSyNaavU8/H5yhCu05dTBeIjZz/ntpJd2Q+jLxL6xp43yrJ3guglsZksAAANjSURBVGje1ZrrVuowEEY/k6Y3Wsr9JiIiimjf//nOWZSe0UWbGdqGg/uny9VNJpNkcsGDFOWF5jnwtQa0jvwgMaF6EAOZI0x8VKAD46muPMr4sKCfJe0C25IARK3Ka+dRRkOGH6rGHpVoyImGNhP4tshNYQNPGOF6AnWlRwVohDbqGo+n0ZRAiT3KoAXaE3qUj3YYkceL0JZnxXiYrmnRSXChAXxV5yGNExEYTVciONIAQa1HReiSpM4ToFvCao9Bx2ivyuOB6D4X4KBziOTSk8AFHnn4qLWPHHl8uGH40xPCEVqRR54E8Xy/HPfStDdejt5j6WJEniEk9F8P+Td604G8QRA3p7/ML5gMpA2CsHfiUZpX8RrLGgTZxLZZ5DWM+2zKlR7Fx+wxr6U358ZQ6TGs5kA98jHfxHE2eFv+i+OKE3lnT8QFrWzN6mtDf832vbzg0OczAYIpZ1G2ZYYfZC9lH9mTISo8XNg+8oI9LliXWQcr6uRhprbZqvjWGhU8nUUDLuPAZtuOWlPB2zmkXEkCbpDOirxaoIYXQYP0Xw/XPaPTZ9LalMqKrJsymQ1uMnjkPjMqRmtsr3zwoO1DtAiLZYRkRWDf7SMIljSgzP2EhcnpX0b2RAAzSqf2j1DKLe1THELJXPAEC/NiTrAnHJildMxnbVYkAmwoGEm6zWAhLjKf8SQ38XicZyuOG+dxmwfkcZvX5HE8Tsnjct4hj0HLeXQvmEehMITLdYE8Idyvc9A0j3Lr9luLdRs+rQtcHbKaNa9DENA6x9ZVVZ51KqqrYLh1m37zIwh5nUjrNl9dv56+tQMhrHsJj+oqbgk60vwcx9l8zdfxhJbUiVnxtQ1ODEaf0n0JEVDdy3XPFkD8tDs02GcBQ6rjuRl7OltPVtX7Rh6P9iXcSlf2uXwfTESSfdamfsO4G0CEkewbj5eCNO1tL88p+H2j4ruHWHz0cR2+aF+//R6pl2OGqxnSOYWke7ZfTKT4cwoVMd2TWqLFYUTnSDsuWnxzROdiEyZaLOb253zuzy1vfw7r/lzZ/Tn57c/93d9juL+XcX/PdKN7s/9/D9jpveZd3NN2du98N/foXbwLuK93Dm3fbdzhO5Tm72ru9p1Qk3dPd/6O62QKfdm7NPfv7IJQ/ap3g528g/wDqUqTZrzIc5QAAAAASUVORK5CYII=');
                }

                .pic_8 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABmCAMAAAAOARRQAAAAb1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD97xUAAAD67BRYUwcAAAAAAACqoQ6FfQoiIAMAAACYjwwQDwH36RTs3xPw4xTm2RPFuhDe0hK6sA9wagjy5RTVyRGjmg1GQgXMwRH/8RWdmYJhAAAAJHRSTlNmADwvRhIaUgtcWftN9oE1H6qUbySeavLl6d6+1raL7c2lesQuwRCyAAAC0ElEQVRo3t3a6XqiMBiG4dfsgOK+1y4O53+Mg4xtqpj0g5CMM88v24v2FhspJsGImlGcCZ2jKdeCcWVG1GiM5AKPygSXQzGKZfCUMxXOmKk13BI3QYwSICZkb0ZpdGgsezFyjI4J051h6NG0IzPL0KtcdWEYesfJjNEIaGxozAxhZYrCcAS3+plhGCDeYihK+MgGRQl3EEcBuJvhGLCVi5lh0NRjRmLYMvOQ0Ri48SOGYfB4m5khQrLFZIiQtgz9Jduc9sXu4/Lg47A9rLu8bOgwyl6qSy+b5aF58AuEzA1D+b+/rv40P14fLPBz4jujQOhw/e2T4vrgnT4KQH/LFNVde5BPB+ST2bSYLX1QN4wAbQTY6GMA7JMxeNR8W31rAbzenc7kDMxvvnHc4EGfzNQ5rmwHAB833ylegc3b7VEn13sHrgvArrptjtvnXiwAHO8OmrguBXANAPuz9sljXXz9wgXsGdtcg6BmGImpJiWAxaRqemu+KGgMb5iMxlTbEsB511xwlleFxOgLI+FhdiXuWr5X1RH3lTsPA1Mz3MeUaHeaA23Hx6xqRvgYeKIfz2oG8Rk9gknAYASVgpHgwzBL7/ErsBQMh0jBMOgUjECeghkDXuZMZV69jEYG2jXNX7n3MjngZej9h8zExTj/Nvs+zLtzCOTOO+buFaVzQGsA3vs0em8LOBIQlOtu6DEMLAXDwVMwK6gUjIRJwYwwSsDomhHxGVYzPD6zqhkZnzH2Vj0io+0Hj5gMbxgVm5H2Q2FERtuPuDEZfmVMXIYw/RB8FwCwL0bFZCRhaiicEZSJrn3oPQ0kZdpuTWVOnpOxjAy58bCTQu0MYUo1PJ5mgjjRdHeayfs0SxGJFlbSLBOlWfRKs4T39xckB3Omz7FYPMzS9/Ms5IdvS3iuTRZBW0aecQNMz+08z7s5qetWq+ffOEbcBvcvbeq7ZmYBWxR/A/EdxSBYfpIgAAAAAElFTkSuQmCC');
                }

                .pic_10 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAMAAAC5dNAvAAAAV1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7UMAAABxaR3u3D7PwTbz4kDWxziqnSxOSBQtKgwmIwoMCwNcVhgK7lTVAAAAEHRSTlMAvgnxNiJdtNKrlI2AcqbgSMwVmAAAAXdJREFUWMPtl9mygyAMQLHuVVsCLrX2/7/zztiMyx2FaBj7wnlmzgSSQBAej+e3RFWehQBhllcRUxUnKaxIk/h8XHfY4B6di6yAHYoTESYh7BImR20lGCmP2R4w0auu1lLqulM9TDyO2KZ8DqqVC1o1TDk+EZvS8h9azfEdPLd3LTeo38fOL8Hlr0Zu0rxwASm/MVbIR+7ywXqh1F+BsUkDGF9B6Cw8t8aka/D87P2GfVpLIzX2r/XksEKkBayXmJTWQdt0eiAlN8XgrChSb8BIa9e1MELJay8J9ITcVvNeabutjLp8XNNRdN24NDfqsmXRUUovM+q+/aopOv3tW0JiJQkYuUzH3yw/FZcVCr+M+U121RXAv6D41+dVlzv/6eE/jBc92/yhgj/yOB3Igpu7cXH28YfZ2ccftU/5SrCDPv43JV36+J+oW7D08b94Kx//A7r2sb7HVh+da3ylcOp7Cqe+UDj1BcKpLxKufOUzDGLh8Xj2+QME8oZ08lYAXgAAAABJRU5ErkJggg==');
                }

                .pic_11 {
                    @extend .span2;
                    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABmCAMAAAAOARRQAAAAjVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAACFhYUAAACvr68AAAAAAAAAAAAjIyMAAABNTU35+fmfn586Ojr9/f1vb2/h4eG9vb3S0tKSkpLz8/PX19fJycm2trb7+/vw8PDFxcXBwcHs7OyXl5d6enr19fXd3d3Z2dnNzc2lpaVjY2NbW1vo6OgAAADk5OT///9qP/nmAAAALnRSTlNmABtbO0dhlS2tDE03bxJ99aN2/IrYuMqc7c7Csvnpvrvlno/x1NDFp4WC4VXcx6ZROwAABB9JREFUaN60zckVhCAQBcBvb4PA4zRhmH98c3YEZWkrgcLWK1IQTWwGMz6SSqC49eprSlBGBWsoXg0J4wYLrTcxMx5xjksNKTopTTeUMCDRVFMUg7SMN2IYZjLYEGMK00iTMS13NzFhQYp9DRmWGPU0AcvCc5PhID81Ahdy3wicyF2T4Sa3mwBHodUQXFG9iQZXFqvNAWdHrRG4k2tDeAFdGsYL+L8RvELOTTE0fPf9g2lWTo2i4Udq2S0nCMRQ+NgfKToKoiC1/lCxFumY93+8dkjZLMjGzva7ynCRTJJzwm7ohziEL89SRtn/mpj3yF8FUmaKYUpqiS/wY8pl1GbOJHXq/7QDdTM7El4T7+1wmQkcXJr8e2JS+DHhMu6/TN6kX1fEbP3/PNAOAOc/YEENy8j7FEC7ZmGTPWsD+sAASR6G5T0RgO+MVqYA8EkNAfqsUtbHSr840I4mD+sNQLRjl/Y72VBLoE4NozmcBDKqxVCyMiahgpP5CNo7I7Ja+LoVdb4km0J5fYC96YDzWJ1RZMu9R+Z2KJyrkRZWVhzK8pfU5+hcDiZQOFjTyLoiSE50w85lrAkeoBBYqaPu1FIaIHU5By9QmPFgSutcV63WmYw6lA4N4AkaZ+Mc4NjEZ65/+t3GjDpcHQaFIjRR06XZRhOezH1gQeypQz0sNUyhElsi4A4SCVMABf3BPFM8QiWz2rkaeQdkwpo67IcVjTFUEhbBWt4fOYANfxQ/CTMMMJYyqnXoaMLKjLIU0Qur4TL3SGLjvKxdey3z2UY9B+XwIzTOK9oyuZnZgdaIdr2D49fPN3Hm25sgEIPxBuNQyPFfGBybMRljuuy+/8dbgk2OiL2HF+T8vTExFyttr7RPL4YvjJ4+c/u6K0ZjypwvFBNKsUHcSr56A/8Om6nfJ3+2N6qNpXhuZkeQ3MwpHr/4UzM7v0JCx4Q5G8vX8Xg8L+rlT+ksajEXG0BjZAY11e/vKR+FBNhz6cTPI9HPGqlckVQ6D7SG6mKekuW0hgMFhFHaiGhFmIAiglStcdBWBIkIj9B5Oa/Ana5r3X0aSwkdt+MGykVvO4omVMSosPlYpIGrgTqstJL16iFifQbt2HYwWVcBRkUL1GgYt98Sd6tue74sFDqsjONTuUIDBg9SLQc+JYGUk6FVaPAISETj6bbgf6LRGCV77coeS8lByn67ij5DI+6AJqR5MzCgETeSInO65xgB7vl2kqITIfkhxA+Dj+2BmML9WEcAcCzA0hCFQEzDx2IgdG1EAGS7bdgDEXIjEj+Sqh+B2JPc7VW897+K2D7b3hI/ayI/Sy8/K7zXLyT/R73p1cExWUydqe/BM5FP+bKEwbXIgqIlI4NxAQyZy3kG7+IkUpdaDf6FY0QugxtKi/owliiC1iiSuEQRAPmo28oqRkQqAAAAAElFTkSuQmCC');
                }
            }

            .is-help-wrapper {
                width: 429px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                /*transform: translateY(100%);*/
                box-sizing: border-box;

                .help-button {
                    height: 46px;
                    line-height: 46px;
                    width: 50%;
                    font-size: 18px;
                    position: relative;
                    text-align: center;
                    color: #4cb7eb;
                    z-index: 0;

                    @extend .hoverCursor;
                }

                $size: 2px;

                .help-yes {
                    &:after, &:before {
                        position: absolute;
                        content: " ";
                        height: 100%;
                        width: 70%;
                        box-sizing: border-box;
                        background-color: white;
                        top: 0;
                        z-index: -1;
                    }

                    &:after {
                        border-top-left-radius: 10px;
                        border-bottom-left-radius: 10px;
                        border: 1px solid #4cb7eb;
                        border-right: none;
                        left: 0;
                        z-index: -1;
                    }

                    &:before {
                        border: 1px solid #4cb7eb;
                        right: $size;
                        z-index: -3;
                        transform: skewX(-10deg);
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                    }
                }

                .help-no {
                    &:after, &:before {
                        position: absolute;
                        content: " ";
                        height: 100%;
                        width: 70%;
                        box-sizing: border-box;
                        background-color: white;
                    }

                    &:after {
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                        border: 1px solid #4cb7eb;
                        border-left: none;
                        right: 0;
                        z-index: -1;
                    }

                    &:before {
                        border: 1px solid #4cb7eb;
                        left: $size;
                        z-index: -1;
                        transform: skewX(-10deg);
                        border-top-left-radius: 10px;
                        border-bottom-left-radius: 10px;
                    }
                }

                .help-active {
                    color: white;
                    font-weight: bolder;

                    &:after, &:before {
                        background-color: #4cb7eb;
                    }
                }
            }

        }
    }

</style>
